import { Fragment, useEffect, useState } from "react";
import { Card, CardTitle, CardBody } from "@progress/kendo-react-layout";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../config/globalVariables";
import GuestEventList from "../../containers/GuestEvent/List/GuestEventList";
import { GuestEventAdd } from "../../containers/GuestEvent/Add/GuestEventAdd";
import { GuestEventUpdate } from "../../containers/GuestEvent/Add/GuestEventUpdate";
import DavetliEtkinlikService from "../../services/srv-davetli/DavetliEtkinlikService";
import { Col, Row } from "reactstrap";

function SummaryCard(text, count, type) {
  return (
    <Card type={type}>
      <CardBody>
        <CardTitle>{count}</CardTitle>
        <p>{text}</p>
      </CardBody>
    </Card>
  );
}

function GuestEvents() {
  const { t } = useTranslation();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [stats, setStats] = useState({});

  useEffect(() => {
    DavetliEtkinlikService.getReport().then((data) => {
      setStats(data);
    });
  }, [isAdded]);

  function goDetail(event) {
    window.open(BASE_URL + "guest-event/" + event.davetlI_ETKINLIK_TANIM_ID);
  }

  return (
    <Fragment>
      {visibleAdd ? (
        <GuestEventAdd
          toggleDialog={() => setVisibleAdd(false)}
          title={t("add_guest_event")}
          isAdded={isAdded}
          setIsAdded={setIsAdded}
        />
      ) : null}

      {visibleUpdate ? (
        <GuestEventUpdate
          toggleDialog={() => setVisibleUpdate(false)}
          title={t("edit_guest_event")}
          isAdded={isAdded}
          setIsAdded={setIsAdded}
          event={selectedEvent}
        />
      ) : null}

      <Row>
        <Col lg="3" md="3" sm="6" xs="12" className="mb-2">
          {SummaryCard(t("this_day_event_count"), stats?.dailyCount, "info")}
        </Col>
        <Col lg="3" md="3" sm="6" xs="12" className="mb-2">
          {SummaryCard(
            t("this_week_event_count"),
            stats?.weeklyCount,
            "warning",
          )}
        </Col>
        <Col lg="3" md="3" sm="6" xs="12" className="mb-2">
          {SummaryCard(
            t("this_month_event_count"),
            stats?.monthlyCount,
            "error",
          )}
        </Col>
        <Col lg="3" md="3" sm="6" xs="12" className="mb-2">
          {SummaryCard(
            t("this_year_event_count"),
            stats?.yearlyCount,
            "success",
          )}
        </Col>
      </Row>

      <GuestEventList
        toggleDialogAdd={() => setVisibleAdd(true)}
        toggleDialogUpdate={() => setVisibleUpdate(true)}
        goDetail={goDetail}
        isAdded={isAdded}
        setIsAdded={setIsAdded}
        setSelectedEvent={setSelectedEvent}
      />
    </Fragment>
  );
}

export { GuestEvents };
